export default __webpack_public_path__ + "static/media/who_is_for_personal_icon.518b858a.svg";